import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "category-sale" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Rapport kategorisalg", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsNav = _resolveComponent("StatisticsNav")!
  const _component_CategorySaleForm = _resolveComponent("CategorySaleForm")!
  const _component_Card = _resolveComponent("Card")!
  const _component_BarChart = _resolveComponent("BarChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_StatisticsNav, { class: "nav" }),
    _hoisted_2,
    _createVNode(_component_Card, { class: "category-sale-form" }, {
      default: _withCtx(() => [
        _createVNode(_component_CategorySaleForm, {
          "default-exclude-weborders": _ctx.excludeWeborders,
          "default-categories": _ctx.selectedCategories,
          "all-categories": _ctx.categories,
          "default-date-from": _ctx.dateFrom,
          "default-date-to": _ctx.dateTo
        }, null, 8, ["default-exclude-weborders", "default-categories", "all-categories", "default-date-from", "default-date-to"])
      ]),
      _: 1
    }),
    (_ctx.data?.length > 0)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "chart-card"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_BarChart, {
              class: "chart",
              "chart-data": _ctx.chartData,
              options: _ctx.chartOptions
            }, null, 8, ["chart-data", "options"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}